import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { useAuth } from "../../../../services/useAuth";
import { API_URL } from "../shared/constants";

export function useSalesByModel(year, month = "all") {
  const { getToken } = useAuth();
  const [modelRows, setModelRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const authH = useCallback(
    () => ({ headers: { Authorization: `Bearer ${getToken()}` } }),
    [getToken],
  );

  useEffect(() => {
    let cancelled = false;

    (async () => {
      setLoading(true);
      try {
        const p = new URLSearchParams({ year: String(year) });
        if (month && month !== "all") p.set("month", String(month));
        const r = await axios.get(
          `${API_URL}/api/analytics/sales?${p}`,
          authH(),
        );
        if (!cancelled) setModelRows(r.data.modelRows || []);
      } catch {
        if (!cancelled) setModelRows([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [year, month, authH]);

  return { modelRows, loading };
}
